import yup from 'src/libs/yup';

const PersonScholarshipVoucherFilterSchema = yup.object().shape({
  status: yup.string().nullable().label('Status'),
});

export default PersonScholarshipVoucherFilterSchema;
